// frontend/src/components/projects/PremiumProjectModal.tsx

import { Link, useNavigate } from 'react-router-dom';

interface PremiumProjectInfoCardProps {
  projectTitle: string;
  projectDescription?: string;
  onClose?: () => void;
  isModal?: boolean;
}

export function PremiumProjectInfoCard({
  projectTitle,
  projectDescription,
  onClose,
  isModal = false,
}: PremiumProjectInfoCardProps) {
  const navigate = useNavigate();

  function handleUpgradeClick() {
    if (onClose) onClose();
    navigate('/pricing');
  }

  return (
    <div className={isModal ? 'premium-project-modal-content' : 'premium-project-info-card'}>
      {isModal && onClose && (
        <button
          type="button"
          onClick={onClose}
          style={{
            position: 'absolute',
            top: 20,
            right: 20,
            background: 'rgba(255, 255, 255, 0.08)',
            border: '1px solid rgba(255, 255, 255, 0.15)',
            color: '#CBD5E1',
            width: 36,
            height: 36,
            borderRadius: '50%',
            cursor: 'pointer',
            fontSize: 18,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'all 0.2s ease',
          }}
          title="Kapat"
        >
          ✕
        </button>
      )}

      <div className="premium-project-icon-badge">👑</div>

      <h3 className="premium-project-title">Premium Proje Görevi</h3>
      <div className="premium-project-subtitle">✨ Bu interaktif görev Premium Plana özeldir</div>

      <div className="premium-project-desc">
        <p style={{ margin: '0 0 10px 0' }}>
          <strong>«{projectTitle}»</strong> projesi, gerçek hayat senaryolarıyla kod yazarak pratik yapabileceğin ve yapay zeka mentörümüzden anında değerlendirme alabileceğin özel bir görevdir.
        </p>
        {projectDescription && (
          <p style={{ margin: '0 0 10px 0', fontSize: '13.5px', color: '#94A3B8', fontStyle: 'italic' }}>
            "{projectDescription}"
          </p>
        )}
        <p style={{ margin: 0, color: '#E2E8F0', fontWeight: 500 }}>
          Sizi direkt ödeme sayfasına yönlendirmek yerine, bu projenin Premium planda geçerli olduğunu hatırlatmak ve size sunulan ayrıcalıklı özellikleri tanıtmak isteriz:
        </p>
      </div>

      <div className="premium-project-features">
        <div className="premium-project-feature-item">
          <span className="premium-project-feature-icon">🚀</span>
          <div className="premium-project-feature-text">
            <strong>Sınırsız Tüm Ders Projeleri</strong>
            <span>Matematik, Fen, Kodlama, Türkçe ve İngilizce derslerindeki tüm interaktif projelere sınırsız erişim sağlayın.</span>
          </div>
        </div>
        <div className="premium-project-feature-item">
          <span className="premium-project-feature-icon">🤖</span>
          <div className="premium-project-feature-text">
            <strong>7/24 AI Mentör & Kod Değerlendirme</strong>
            <span>Yazdığınız kodları anında analiz eden, hatalarınızı açıklayan ve ipuçları sunan akıllı mentör desteği alın.</span>
          </div>
        </div>
        <div className="premium-project-feature-item">
          <span className="premium-project-feature-icon">🏆</span>
          <div className="premium-project-feature-text">
            <strong>Onaylı Sertifikalar & Kariyer Ligi</strong>
            <span>Projeleri tamamlayarak yüksek XP kazanın, liglerde yükselin ve portfolyonuza özel başarı sertifikaları ekleyin.</span>
          </div>
        </div>
      </div>

      <div className="premium-project-actions">
        <button
          type="button"
          className="premium-btn-upgrade"
          onClick={handleUpgradeClick}
        >
          ✨ Premium Planları İncele →
        </button>
        {onClose ? (
          <button
            type="button"
            className="premium-btn-close"
            onClick={onClose}
          >
            Vazgeç ve Kapat
          </button>
        ) : (
          <Link to="/projects" className="premium-btn-close">
            ⬅️ Projelere Dön
          </Link>
        )}
      </div>
    </div>
  );
}

interface PremiumProjectModalProps {
  isOpen: boolean;
  onClose: () => void;
  projectTitle: string;
  projectDescription?: string;
}

export function PremiumProjectModal({
  isOpen,
  onClose,
  projectTitle,
  projectDescription,
}: PremiumProjectModalProps) {
  if (!isOpen) return null;

  return (
    <div
      className="premium-project-modal-overlay"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <PremiumProjectInfoCard
        projectTitle={projectTitle}
        projectDescription={projectDescription}
        onClose={onClose}
        isModal={true}
      />
    </div>
  );
}
